export const buttonSizeScale = {
  xs: {
    button: "h-6 px-2 text-xs",
    icon: "h-4 w-4 rounded-full",
  },
  sm: {
    button: "h-8 px-3 text-xs",
    icon: "h-6 w-6 rounded-full",
  },
  md: {
    button: "h-10 px-4 text-sm",
    icon: "h-8 w-8 rounded-full",
  },
  lg: {
    button: "h-12 px-6 text-base",
    icon: "h-10 w-10 rounded-full",
  },
  xl: {
    button: "h-14 px-8 text-lg",
    icon: "h-12 w-12 rounded-full",
  },
};
